import {Component, OnInit, Input, Optional} from '@angular/core';

// Classes.
import {Article} from '../../classes/article';


@Component({
  selector: 'app-article-result',
  templateUrl: './article-result.component.html',
  styleUrls: ['./article-result.component.scss']
})
export class ArticleResultComponent implements OnInit {

  @Input() article: Article;
  @Input() higlight: string;


  constructor() {}

  ngOnInit() {
  }

  get isMobile(){
    return /Android|iPhone/i.test(window.navigator.userAgent);
  }
}
